"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = exports.baseButtonStyles = exports.sizes = exports.variants = exports.buildVariant = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const buildVariant = (variant) => {
    const builder = ({ disabled }) => (0, classnames_1.default)(variant.base, disabled ? variant.disabled : variant.enabled);
    return Object.assign(builder, variant);
};
exports.buildVariant = buildVariant;
exports.variants = {
    yellow: (0, exports.buildVariant)({
        base: 'button bg-yellow text-gray',
        enabled: 'hover:text-gray-3 hover:bg-yellow-hover focus:text-gray-3 focus:bg-yellow-hover active:bg-yellow-active',
        disabled: 'hover:bg-yellow active:bg-yellow opacity-70 cursor-not-allowed pointer-events-none',
    }),
    blue: (0, exports.buildVariant)({
        base: 'button bg-blue text-white',
        enabled: 'hover:text-white hover:bg-blue-hover focus:text-white focus:bg-blue-hover active:bg-blue-active',
        disabled: 'hover:bg-blue active:bg-blue opacity-70 cursor-not-allowed pointer-events-none',
    }),
    white: (0, exports.buildVariant)({
        base: 'button bg-white text-gray',
        enabled: 'hover:text-black focus:text-black hover:bg-gray-e focus:bg-gray-e active:bg-gray-e hover:underline',
        disabled: 'hover:bg-white active:bg-white opacity-70 cursor-not-allowed pointer-events-none',
    }),
    gray: (0, exports.buildVariant)({
        base: 'button bg-gray-e text-gray',
        enabled: 'hover:bg-gray-d focus:bg-gray-d active:bg-gray-d hover:text-black',
        disabled: 'hover:bg-gray active:bg-gray opacity-70 cursor-not-allowed pointer-events-none',
    }),
    'gray-outline': (0, exports.buildVariant)({
        base: 'button bg-transparent text-gray border border-gray border-2',
        enabled: 'hover:shadow-2nd-button-inner',
        disabled: 'hover:bg-gray active:bg-gray opacity-70 cursor-not-allowed pointer-events-none',
    }),
    'white-outline': (0, exports.buildVariant)({
        base: 'button bg-transparent text-white border border-white border-2',
        enabled: 'hover:shadow-[inset_0_0_0_1px_#ffffff]',
        disabled: 'hover:bg-gray active:bg-gray opacity-70 cursor-not-allowed pointer-events-none',
    }),
    'gray-outline-thin': (0, exports.buildVariant)({
        base: 'button bg-gray-fa text-gray border border-d',
        enabled: 'hover:border-gray hover:shadow-2nd-button-inner',
        disabled: 'hover:bg-gray active:bg-gray opacity-70 cursor-not-allowed pointer-events-none',
    }),
    custom: (0, exports.buildVariant)({
        base: '',
        enabled: '',
        disabled: '',
    }),
};
exports.sizes = {
    xl: 'px-6 py-3 text-xl',
    lg: 'px-6 pt-2 pb-2.5 text-base',
    md: 'px-4 pt-1 pb-1.5 text-base',
    sm: 'px-4 py-1.5 text-sm',
    custom: '',
};
exports.baseButtonStyles = `block rounded-full leading-relaxed text-center transition-all duration-200 solid-focus-ring`;
function Button(_a) {
    var { className, variant = 'yellow', size = 'md', disabled = false, as: Component = 'button' } = _a, props = __rest(_a, ["className", "variant", "size", "disabled", "as"]);
    return (react_1.default.createElement(Component, Object.assign({ className: (0, classnames_1.default)(exports.baseButtonStyles, exports.variants[variant]({ disabled }), exports.sizes[size], className) }, props)));
}
exports.Button = Button;
